import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './styleguide-preview.css'

const StyleguidePreview = ({ children, description, title, spacing, dark }) => {
  const containerClass = classNames('container', {
    'container-horizontal-space': spacing === 'horizontal',
    'container-vertical-space': spacing === 'vertical',
    'container-dark': dark,
  })

  return (
    <div styleName="styleguide-preview">
      <div styleName="header">
        <h2 styleName="title">{title}</h2>
        {description && <p styleName="description">{description}</p>}
      </div>
      <div styleName={containerClass}>
        {children}
      </div>
    </div>
  )
}

StyleguidePreview.propTypes = {
  children: PropTypes.any,
  dark: PropTypes.bool,
  description: PropTypes.string,
  spacing: PropTypes.oneOf(['horizontal', 'vertical']),
  title: PropTypes.string.isRequired,
}

export default CSSModules(StyleguidePreview, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/styleguide-preview/styleguide-preview.js
 **/